/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function LoadLibrary(liburl,callback){
    var jscript = document.createElement("script");
    jscript.type = 'text/javascript';
    jscript.src = liburl;
    //for IE type browsers
    if (jscript.readyState) { 
        jscript.onreadystatechange = function () {
            if (jscript.readyState == "loaded" || jscript.readyState == "complete") {
                jscript.onreadystatechange = null;
                callback();
            }
        };
    } else {
        jscript.onload = function () {
            callback();
        };
    }
    document.getElementsByTagName("head")[0].appendChild(jscript);
}


if (!window.jQuery) {  
    LoadLibrary('https://code.jquery.com/jquery-3.3.1.min.js',
        function(){
            console.log('jQuery loaded');
        }
    );         
}



function defer(method) {
    if (window.jQuery) {
        method();
    } else {
        setTimeout(function() { defer(method) }, 50);
    }
}

defer(function(){
$(document).ready(function(){
	$( ".Product__Slideshow .Product__SlideItem" ).clone(true).appendTo( ".slide-placeholder" );
});


	window.VIG = window.VIG || {};
	VIG.loaded = false;
	VIG.VariantChangeCallback = function(){
    		var visible_ids = $('.slide-placeholder img:visible').map(function() {
    			return $(this).data('image-id');
    		}).get();
    		$(".flickity-page-dots button").hide();
          	var visible_index = 0;
    		var slidesToAdd = [];
    
    		visible_ids.forEach(function(element) {
    		slidesToAdd.push($('.slide-placeholder [data-image-id='+element+']').closest('.Product__SlideItem'));
    		});
    		
            var $sliders = $('.Product__Slideshow.flickity-enabled');
          
        	  $sliders.each(function() {
                
                var $slider = $(this);
                var $sliderInstance = Flickity.data(this);
                if ($sliderInstance != undefined ) {
                  
                    $sliderInstance.remove($('.Product__Slideshow .Product__SlideItem'));
                    slidesToAdd.forEach(function(element) {
                    	$sliderInstance.append(element.clone(true));
                      	visible_index = element.attr('data-image-media-position');
                      	$(".flickity-page-dots button[data-index='"+visible_index+"']").show();
                    });
                } 
                else{
                console.log('slider instance undefined');
                }
            });		
    		
          $(".flickity-page-dots button[data-index]:visible").first().addClass('is-selected');
            window.scrollTo(0, 0);
    
        }
	
});/*FIXED BY VIP:2021-03-10 22:17:03 UTC*/

if (!customElements.get('product-item-color-swatch')) {
  customElements.define(
    'product-item-color-swatch',
    class ProductItemColorSwatch extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.productItem = this.closest('.ProductItem');
        this.input = this.querySelector('.ColorSwatch__Radio'); 
        this.variantId = this.input.dataset.variantId;
        this.variantUrl = this.input.dataset.variantUrl;
        this.submitButton = this.productItem.querySelector('[data-add-to-cart]');

        if (!this.submitButton) {
          if (this.productItem.nextElementSibling) this.submitButton = this.productItem.nextElementSibling.querySelector('[data-add-to-cart]');
        }

        this.addEventListeners();
      }

      addEventListeners() {
        this.input.addEventListener('change', () => this.onColorSwatchChanged());
      }

      onColorSwatchChanged() {
        // We need to change the URL of the various links
        if (this.productItem.querySelector('.ProductItem__ImageWrapper')) this.productItem.querySelector('.ProductItem__ImageWrapper').setAttribute('href', this.variantUrl);
        if (this.productItem.querySelector('.ProductItem__Title > a')) this.productItem.querySelector('.ProductItem__Title > a').setAttribute('href', this.variantUrl);

        // If we have a custom image for the variant, we change it
        var originalImageElement = this.productItem.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate)');

        if (this.input.hasAttribute('data-image-url') && this.input.getAttribute('data-image-id') !== originalImageElement.getAttribute('data-image-id')) {
          var newImageElement = document.createElement('img');
          newImageElement.className = 'ProductItem__Image Image--fadeIn Image--lazyLoad';
          newImageElement.setAttribute('data-image-id', this.input.getAttribute('data-image-id'));
          newImageElement.setAttribute('data-src', this.input.getAttribute('data-image-url'));
          newImageElement.setAttribute('data-widths', this.input.getAttribute('data-image-widths'));
          newImageElement.setAttribute('data-sizes', 'auto');

          // Replace the original node
          if (window.theme.productImageSize === 'natural') {
            originalImageElement.parentNode.style.paddingBottom = 100.0 / this.input.getAttribute('data-image-aspect-ratio') + '%';
          }

          originalImageElement.parentNode.style.setProperty('--aspect-ratio', this.input.getAttribute('data-image-aspect-ratio'));
          originalImageElement.parentNode.replaceChild(newImageElement, originalImageElement);
        }

        // We change the variant ID in the atc button if the variant is available
        if (this.input.disabled || !this.submitButton) return;
        this.submitButton.setAttribute('data-variant-id', this.variantId);
      }
    }
  );
}

if (!customElements.get('product-item-form')) {
  customElements.define(
    'product-item-form',
    class ProductItemForm extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.submitButton = this.querySelector('[data-add-to-cart]');
        this.variantId = this.submitButton.dataset.variantId;
        this.quantity = parseInt(this.submitButton.dataset.variantQuantity) || 1;

        this.addEventListeners();
      }

      addEventListeners() {
        this.submitButton.addEventListener('click', () => this.onSubmitButtonClick());
      }

      onSubmitButtonClick() {
        console.log('Ajout depuis une carte produit');
        this.variantId = this.submitButton.dataset.variantId;

        let formData = {
          'items': [{
            'id': this.variantId,
            'quantity': this.quantity
            }]
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          document.documentElement.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: this.variantId,
              quantity: this.quantity
            }
          }));
          return response.json();
        })
        .catch(error => {
          console.error(error);
        });
      }
    }
  );
}

// FIX iOS Safari Grid pour Prestige Theme - Ajout sécurisé
defer(function(){
  $(document).ready(function(){
    try {
      var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      
      if (isIOS) {
        console.log('iOS détecté - Fix grid activé');
        
        if ($('#ios-grid-fix').length === 0) {
          $('head').append('<style id="ios-grid-fix">@media screen and (max-width: 640px){.ProductList.Grid,.ProductList--grid{display:-webkit-flex !important;display:flex !important;-webkit-flex-wrap:wrap !important;flex-wrap:wrap !important;}.ProductList .Grid__Cell{-webkit-flex:0 0 calc(50% - 10px) !important;flex:0 0 calc(50% - 10px) !important;max-width:calc(50% - 10px) !important;margin:5px !important;}}</style>');
        }
      }
    } catch(e) {
      console.error('Erreur fix iOS:', e);
    }
  });
});